// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"0ffb09cb","445":"e512186e","818":"302d13ae","989":"7f72eb88"}[chunkId] + ".chunk.css";
};